import { Analytics } from './analytics';

let downloadSelector = $('a[download], a[href^="/globalassets"], a[href^="/contentassets"]');

downloadSelector.click((e) => {
    let target = $(e.target).attr('href');
    let lastSlash = target.lastIndexOf('/');
    let fileName = target.substring(lastSlash + 1);
    
    Analytics.sendEvent('File', fileName, window.location.pathname)
});